import { useCallback, useEffect, useState } from "react";
import { Trash2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { http, errorText } from "@/lib/api";

const AddForm = ({ onAdded }) => {
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await http.post("/admin/users", f);
      setF({ name: "", email: "", password: "" });
      toast("Admin account added");
      onAdded();
    } catch (ex) { toast.error(errorText(ex.response?.data?.detail)); }
  };
  const field = (k, label, type = "text") => (
    <label className="block text-[11px] font-semibold uppercase tracking-wider text-hv-muted">
      {label}
      <input type={type} required={k !== "name"} minLength={k === "password" ? 10 : undefined} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
        data-testid={`admin-user-${k}-input`} className="mt-1 w-full border border-hv-rule px-2 py-1.5 text-[13px] normal-case tracking-normal text-hv-text focus:border-hv-navy focus:outline-none" />
    </label>
  );
  return (
    <form onSubmit={submit} className="mt-5 grid items-end gap-3 md:grid-cols-4" data-testid="admin-user-add-form">
      {field("name", "Name")}{field("email", "Email", "email")}{field("password", "Password (10+ characters)", "password")}
      <button type="submit" className="hv-btn-light hv-btn-sm" data-testid="admin-user-add-button"><UserPlus size={14} /> Add admin</button>
    </form>
  );
};

export const AdminUsersPanel = ({ me }) => {
  const [users, setUsers] = useState([]);
  const load = useCallback(() => http.get("/admin/users").then((r) => setUsers(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const remove = async (u) => {
    if (!window.confirm(`Remove ${u.email}? They will no longer be able to sign in.`)) return;
    try { await http.delete(`/admin/users/${u.id}`); toast("Admin removed"); load(); } catch (ex) { toast.error(errorText(ex.response?.data?.detail)); }
  };
  return (
    <section className="border border-hv-rule bg-white p-6" data-testid="panel-admin-users">
      <h2 className="border-b border-hv-rule pb-3 font-heading text-[14px] font-semibold text-hv-text">Admin accounts <span className="font-normal text-hv-muted">· admins see analytics but not costs or settings</span></h2>
      <ul className="mt-3 divide-y divide-hv-rule text-[13px]" data-testid="admin-users-list">
        {users.map((u) => (
          <li key={u.id} className="flex items-center justify-between gap-3 py-2" data-testid={`admin-user-row-${u.email}`}>
            <span><strong>{u.name}</strong> <span className="text-hv-muted">{u.email}</span></span>
            <span className="flex items-center gap-3">
              <span className="text-[11px] font-semibold uppercase tracking-wider text-hv-navy">{u.role === "super_admin" ? "Super admin" : "Admin"}</span>
              {u.role !== "super_admin" && u.email !== me.email && (
                <button type="button" onClick={() => remove(u)} aria-label={`Remove ${u.email}`} className="text-hv-muted transition-colors hover:text-red-700" data-testid={`admin-user-remove-${u.email}`}><Trash2 size={15} /></button>
              )}
            </span>
          </li>
        ))}
      </ul>
      <AddForm onAdded={load} />
    </section>
  );
};
